import Pagination from 'react-js-pagination';
import * as S from './style';
import DoubleArrowNext from '@/components/Icon/DoubleArrowNext';
import DoubleArrowPrev from '@/components/Icon/DoubleArrowPrev';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';

interface PaginationProps {
	children: React.ReactNode;
	activePage?: number;
	itemsPerPage?: number;
	totalItems?: number;
	onChange?: (pageNumber: number) => void;
}

const TablePagination = ({
	children,
	activePage = 1,
	itemsPerPage = 10,
	totalItems = 450,
	onChange = (pageNumber) => console.log(`Page changed to ${pageNumber}`),
}: PaginationProps) => (
	<S.PaginationContainer>
		{children}
		<Pagination
			activePage={activePage}
			itemsCountPerPage={itemsPerPage}
			totalItemsCount={totalItems}
			pageRangeDisplayed={5}
			onChange={onChange}
			firstPageText={<DoubleArrowPrev width="24" height="24" />}
			lastPageText={<DoubleArrowNext width="24" height="24" />}
			prevPageText={<SingleArrowPrev width="24" height="24" />}
			nextPageText={<SingleArrowNext width="24" height="24" />}
			linkClassFirst="first-page-btn"
			linkClassLast="last-page-btn"
			linkClassPrev="prev-page-btn"
			linkClassNext="next-page-btn"
		/>
	</S.PaginationContainer>
);

export default TablePagination;
